export default __webpack_public_path__ + "static/media/img10.6c2c4451.png";